import React, { Suspense, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, Environment, PerspectiveCamera } from '@react-three/drei';
import * as THREE from 'three';

function Diamond() {
  const meshRef = useRef();

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y += 0.01;
      meshRef.current.position.y = Math.sin(state.clock.elapsedTime) * 0.1 + 1.5;
    }
  });

  const geometry = new THREE.OctahedronGeometry(0.8, 0);

  
  
  return (
    <mesh ref={meshRef} geometry={geometry} position={[0, 1.5, 0]}>
      <meshPhysicalMaterial
        color="#B9F2FF"
        metalness={0.9}
        roughness={0.05}
        transparent
        opacity={0.95}
        reflectivity={1}
        clearcoat={1}
        clearcoatRoughness={0}
      />
    </mesh>
  );
}

function Ring() {
  const ringRef = useRef();

  useFrame((state) => {
    if (ringRef.current) {
      ringRef.current.rotation.y = state.clock.elapsedTime * 0.3;
    }
  });

  return (
    <group ref={ringRef}>
      <mesh rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[1.2, 0.12, 16, 100]} />
        <meshStandardMaterial
          color="#FFD700"
          metalness={1}
          roughness={0.2}
        />
      </mesh>

      <mesh position={[0, 0.6, 0]}>
        <cylinderGeometry args={[0.25, 0.4, 0.6, 6]} />
        <meshStandardMaterial
          color="#FFD700"
          metalness={1}
          roughness={0.2}
        />
      </mesh>
    </group>
  );
}

function RingScene() {
  return (
    <>
      <PerspectiveCamera makeDefault position={[0, 2, 5]} />
      <OrbitControls 
        enableZoom={false}
        enablePan={false}
        autoRotate
        autoRotateSpeed={0.5}
      />
      
      <ambientLight intensity={0.5} />
      <spotLight position={[10, 10, 10]} angle={0.3} intensity={1} />
      <pointLight position={[0, 5, 0]} intensity={0.8} color="#FFB6C1" />
      
      <Ring />
      <Diamond />
      
      <Environment preset="sunset" />
    </>
  );
}

function FinalMessage() {
  return (
    <section className="final-message">
      <div className="ring-canvas">
        <Suspense fallback={<div>Loading...</div>}>
          <Canvas>
            <RingScene />
          </Canvas>
        </Suspense>
      </div>

      <div className="final-text">
        <h2>Will you be mine? 💍</h2>
        <p>
          This isn't just for Valentine's Day. This is a promise of every sunrise we'll share, 
          every dream we'll chase, and every moment we'll treasure together.
        </p>
        <p style={{ marginTop: '2rem', fontSize: '2rem', fontWeight: 600 }}>
          I love you, Sojin Kim 💕
        </p>
      </div>
    </section>
  );
}

export default FinalMessage;